import { ChargeWaiverConstant } from "presentation/constant/ChargeWaiver/ChargeWaiverConstant";
import { useChargeWaiverVM } from "presentation/hook/ChargeWaiver/useChargeWaiverVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useChargeWaiverTracked } from "presentation/store/ChargeWaiver/ChargeWaiverProvider";
import { CriteriaItemContainer } from "presentation/view/components/CriteriaItemContainer";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import { memo, useCallback, useMemo, useState } from "react";
import { FieldType, HPHButton, IconButton, IFieldValue, Loader } from "veronica-ui-component/dist/component/core";
import { SidebarActionBar, SidebarActionCross, Sidebarheader, SidebarTitle } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";


const ChargeWaiverReasonPanel = () => {
    const CHARGE_WAIVER_CONSTANT = ChargeWaiverConstant.Edit;
    const [chargeWaiverState] = useChargeWaiverTracked();
    const chargeWaiverVM = useChargeWaiverVM();
    const messageBarVM = useMessageBarVM();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const { searchCriteria, selectedRows, isShowRejectPanel, isShowReversePanel, reasonCode, dynamicOptions } = chargeWaiverState;
    const reasonDropdownOptions = isShowRejectPanel ? dynamicOptions.rejectReasonDropdownOptions : dynamicOptions.reverseReasonDropdownOptions;

    const saveButtonClicked = useCallback(() => {
        setIsLoading(true);
        if (isShowReversePanel) {
            chargeWaiverVM.onReverse(selectedRows, reasonCode || '').then(async (data) => {
                if (data && data.success) {
                    if (data.data && data.data !== 'OK') {
                        setIsLoading(false);
                        messageBarVM.showError(data.data);
                    } else {
                        setIsLoading(false);
                        messageBarVM.showSuccess("Reverse Successfully.");
                        chargeWaiverVM.onReasonCloseClick();
                        await chargeWaiverVM.searchChargeWaiverApprovalData(searchCriteria);
                    }
                } else {
                    setIsLoading(false);
                    messageBarVM.showError("Reverse Failed.");
                }
            })
        }
        if (isShowRejectPanel) {
            chargeWaiverVM.onReject(selectedRows, reasonCode || '').then(async (data) => {
                if (data && data.success) {
                    if (data.data && data.data !== 'OK') {
                        setIsLoading(false);
                        messageBarVM.showError(data.data);
                    } else {
                        setIsLoading(false);
                        messageBarVM.showSuccess("Reject Successfully.");
                        chargeWaiverVM.onReasonCloseClick();
                        await chargeWaiverVM.searchChargeWaiverApprovalData(searchCriteria);
                    }
                } else {
                    setIsLoading(false);
                    messageBarVM.showError("Reject Failed.");
                }
            })
        }
    }, [isShowReversePanel, reasonCode, chargeWaiverVM, searchCriteria, isShowRejectPanel, messageBarVM, setIsLoading, selectedRows])

    const closeButtonClicked = useCallback(() => {
        chargeWaiverVM.onReasonCloseClick();
    }, [chargeWaiverVM])

    const memoReason = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "280px", marginBottom: "12px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={reasonCode || ''}
                fieldValue={reasonCode}
                fieldLabel={CHARGE_WAIVER_CONSTANT.REASON_CODE}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'reasonCode'}
                maxLength={60}
                options={reasonDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    chargeWaiverVM.onEditFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [chargeWaiverVM, reasonCode, CHARGE_WAIVER_CONSTANT.REASON_CODE, reasonDropdownOptions])

    return (
        <div className='side-form-content-wrapper'>
            <div className={'flex-row'}>
                <div className={'flex-row-item flex-row-item-full-width'}>
                    <Sidebarheader>
                        <SidebarTitle>
                            {isShowRejectPanel && ChargeWaiverConstant.Title.REJECT_REASON}
                            {isShowReversePanel && ChargeWaiverConstant.Title.REVERSE_REASON}
                        </SidebarTitle>
                        <SidebarActionCross>
                            <IconButton
                                fileName="Icon-cross" size="medium" toolTipText='Close' toolTipArrow={false} onClick={closeButtonClicked} />
                        </SidebarActionCross>
                    </Sidebarheader>
                </div>
            </div>
            {isLoading &&
                <Loader Indicator="Spinner" size="Medium" />}
            {<>
                <div className={'add-edit-form'} style={{ height: '75vh', maxHeight: '75vh', overflow: 'auto' }}>
                    <div className="flex-row-auto">
                        <div className={'flex-row-item'}>
                            <CriteriaItemContainer>
                                {memoReason}
                            </CriteriaItemContainer>
                        </div>
                    </div>
                </div>
                <SidebarActionBar>
                    <HPHButton label={'Cancel'} size={'Small'} theme={'Secondary'} onClick={closeButtonClicked} />
                    <HPHButton label={'Update'} size={'Small'} theme={'Primary'} onClick={saveButtonClicked} />
                </SidebarActionBar>
            </>}
        </div>
    );
}

export default memo(ChargeWaiverReasonPanel);